import { render, staticRenderFns } from "./FooterNavigationDesktop.vue?vue&type=template&id=47590a4e&"
import script from "./FooterNavigationDesktop.vue?vue&type=script&lang=js&"
export * from "./FooterNavigationDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports